
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Campaign View Logs</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Campaign View Logs</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
        <div class="container-fluid">
          <div class="card" id="CampaignViewLog">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
                <div class="card-tools">
                  <router-link class="btn btn-info" :to="{name: 'CampaignViewLogList'}"><i class="fas fa-list"></i> List
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                    <div class="col-8">
                    
                    
            <div class="form-group required" >
              <label class="control-label">Organization</label>
              <multiselect id="organization_id" name="organization_id" :options="Object.keys(pre.organization_id)" :custom-label="opt => pre.organization_id[opt]"
                     v-bind:class="{'has-error' : errors.has('organization_id')}"
                     v-validate="'required'"
                     v-model="value.organization_id" class="organization_id"
                     placeholder="Select Organization" :searchable="true"
                     :close-on-select="true" :show-labels="false"></multiselect>
              <div class="help text-danger" v-show="errors.has('organization_id')">
                {{ errors.first("organization_id") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Campaign</label>
              <multiselect id="campaign_id" name="campaign_id" :options="Object.keys(pre.campaign_id)" :custom-label="opt => pre.campaign_id[opt]"
                     v-bind:class="{'has-error' : errors.has('campaign_id')}"
                     v-validate="'required'"
                     v-model="value.campaign_id" class="campaign_id"
                     placeholder="Select Campaign" :searchable="true"
                     :close-on-select="true" :show-labels="false"></multiselect>
              <div class="help text-danger" v-show="errors.has('campaign_id')">
                {{ errors.first("campaign_id") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Ads Type</label>
              <input type="text" id="ads_type" name="ads_type"
                     v-bind:class="{'has-error' : errors.has('ads_type')}"
                     v-validate="'required'"
                     v-model="value.ads_type" class="form-control ads_type"
                     placeholder="Ads Type">
              <div class="help text-danger" v-show="errors.has('ads_type')">
                {{ errors.first("ads_type") }}
              </div>
            </div>
            <div class="form-group " >
              <label class="control-label">User Agent</label>
              <textarea id="client_user_agent" name="client_user_agent"
                 
                 
                 v-model="value.client_user_agent" class="form-control client_user_agent"
                 placeholder="User Agent"
                 rows="3"></textarea>
              
            </div>
            <div class="form-group " >
              <label class="control-label">Referrer</label>
              <input type="text" id="referrer" name="referrer"
                     
                     
                     v-model="value.referrer" class="form-control referrer"
                     placeholder="Referrer">
              
            </div>
            <div class="form-group " >
              <label class="control-label">IP Address</label>
              <input type="text" id="client_ip" name="client_ip"
                     
                     
                     v-model="value.client_ip" class="form-control client_ip"
                     placeholder="IP Address">
              
            </div>
            <div class="form-group " >
              <label class="control-label">Country</label>
              <input type="text" id="client_country" name="client_country"
                     
                     
                     v-model="value.client_country" class="form-control client_country"
                     placeholder="Country">
              
            </div>
            <div class="form-group " >
              <label class="control-label">City</label>
              <input type="text" id="client_city" name="client_city"
                     
                     
                     v-model="value.client_city" class="form-control client_city"
                     placeholder="City">
              
            </div>
            <div class="form-group " >
              <label class="control-label">Browser</label>
              <input type="text" id="client_browser" name="client_browser"
                     
                     
                     v-model="value.client_browser" class="form-control client_browser"
                     placeholder="Browser">
              
            </div>
            <div class="form-group " >
              <label class="control-label">Browser Name</label>
              <input type="text" id="client_browser_name" name="client_browser_name"
                     
                     
                     v-model="value.client_browser_name" class="form-control client_browser_name"
                     placeholder="Browser Name">
              
            </div>
            <div class="form-group " >
              <label class="control-label">Browser Version</label>
              <input type="text" id="client_browser_version" name="client_browser_version"
                     
                     
                     v-model="value.client_browser_version" class="form-control client_browser_version"
                     placeholder="Browser Version">
              
            </div>
            <div class="form-group " >
              <label class="control-label">Browser Engine</label>
              <input type="text" id="client_browser_engine" name="client_browser_engine"
                     
                     
                     v-model="value.client_browser_engine" class="form-control client_browser_engine"
                     placeholder="Browser Engine">
              
            </div>
            <div class="form-group " >
              <label class="control-label">Platform</label>
              <input type="text" id="client_os" name="client_os"
                     
                     
                     v-model="value.client_os" class="form-control client_os"
                     placeholder="Platform">
              
            </div>
            <div class="form-group " >
              <label class="control-label">Operating system</label>
              <input type="text" id="client_os_name" name="client_os_name"
                     
                     
                     v-model="value.client_os_name" class="form-control client_os_name"
                     placeholder="Operating system">
              
            </div>
            <div class="form-group " >
              <label class="control-label">Operating System Version</label>
              <input type="text" id="client_os_version" name="client_os_version"
                     
                     
                     v-model="value.client_os_version" class="form-control client_os_version"
                     placeholder="Operating System Version">
              
            </div>
            <div class="form-group " >
              <label class="control-label">Device Type</label>
              <input type="text" id="client_device_type" name="client_device_type"
                     
                     
                     v-model="value.client_device_type" class="form-control client_device_type"
                     placeholder="Device Type">
              
            </div>
            <div class="form-group " >
              <label class="control-label">Device Vendor</label>
              <input type="text" id="client_device_name" name="client_device_name"
                     
                     
                     v-model="value.client_device_name" class="form-control client_device_name"
                     placeholder="Device Vendor">
              
            </div>
            <div class="form-group " >
              <label class="control-label">Device Brand</label>
              <input type="text" id="client_device_model" name="client_device_model"
                     
                     
                     v-model="value.client_device_model" class="form-control client_device_model"
                     placeholder="Device Brand">
              
            </div>
                    </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
                <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
              </div>
            </form>
          </div>
        </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "CampaignViewLogForm",
  metaInfo: {
    title: "Campaign View Logs | Dotlines"
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    
    value: {
        
        
    },
    pre: {
      organization_id: {},campaign_id: {},
    }
  }),
  methods: {
    
    
    organizationIdOptions: function () {
      return new Promise((resolve, reject) => {
        axios.get("/get-dropdown-options/3")
          .then(response => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    campaignIdOptions: function () {
      return new Promise((resolve, reject) => {
        axios.get("/get-dropdown-options/5")
          .then(response => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    
    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/campaign_view_logs";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/campaign_view_logs/" + _this.$route.params.id
            method = "PUT";
          }

          

          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "CampaignViewLogList"});
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message);
            }
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/campaign_view_logs/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      await this.organizationIdOptions().then(organization_id => {
        this.pre.organization_id = organization_id;
      });
      await this.campaignIdOptions().then(campaign_id => {
        this.pre.campaign_id = campaign_id;
      });
      
      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
        }).catch((error) => {
          console.log(error.response);
        });
        
        
      }
      
      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>

        